import { Card, CardFooter, CardHeader, Image, makeStyles, Persona, Text, Title3 } from "@fluentui/react-components";
import { Link } from "react-router-dom";
import { Avatar } from "../../components/avatar/Avatar";
import ITeamMember from "../../models/ITeamMember";
import IEntryPreivew from "../../models/blog/IEntryPreview";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    card: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    cardCol: {
        width: 'calc(33% - 8px)',
        margin: '0',

        "@media (max-width: 768px)": {
            width: '100%',
            padding: "0 1rem"
        }
    },
    cardImage: {
        width: '100%',
        height: '150px',
        objectFit: 'cover',
    },
    cardTitle: {
        marginTop: 0,
    },
    link: {
        textDecoration: 'none'
    }
});

export default function BlogCard(props:{ blog: IEntryPreivew }) {
    const { t } = useTranslation("blog");
    const { blog } = props;
    const styles = useStyles();

    const person: ITeamMember = {
        id: blog.authorId!,
        name: blog.author!,
        position: ""
    };

    const publishedDate = new Date(blog.published);
    const publishedStr = publishedDate.toDateString();
    const readTime = blog.readTime
        ? blog.readTime === 1
            ? t("readTime.one")
            : t("readTime.other", { count: blog.readTime })
        : "";

    return (
        <div className={styles.cardCol}>
            <Link to={`/blog/${blog.slug}`} className={styles.link}>
                <Card className={styles.card}>
                    <Image
                        src={blog.thumbnail.url}
                        alt={blog.thumbnail.altText}
                        className={styles.cardImage}
                    />
                    <CardHeader
                        header={<Title3 block as="h3" className={styles.cardTitle}>{blog.title.title}</Title3>}
                        description={<Text block>{blog.subtitle || blog.metaDescription}</Text>}
                        />
                    <CardFooter>
                        <Persona
                            name={person.name}
                            avatar={Avatar(person)}
                            secondaryText={publishedStr}
                            tertiaryText={readTime}
                            size="extra-large"
                            />
                    </CardFooter>
                </Card>
            </Link>
        </div>
    );
}